export default __webpack_public_path__ + "static/media/Speaker_List_Example_3.e6420020.png";